import { GetParticipationsByEmployeeResponse, ParticipationItem } from '@/types/Psychosocial';
import {
	ParticipationItemDTO,
	GetParticipationsByEmployeeResponseDTO
} from '@/core/dto/psychosocial-report/get-participations-by-employee';

export class GetParticipationsByEmployeeMapper {
	constructor(private readonly data: GetParticipationsByEmployeeResponseDTO) {}

	public toDomain(): GetParticipationsByEmployeeResponse {
		return {
			open: this.data.open.map((item) => this.mapParticipation(item)),
			completed: this.data.completed.map((item) => this.mapParticipation(item))
		};
	}

	private mapParticipation(participation: ParticipationItemDTO): ParticipationItem {
		return {
			updated_at: participation.updated_at ? new Date(participation.updated_at) : undefined,
			expires_at: participation.expires_at ? new Date(participation.expires_at) : undefined,
			created_at: new Date(participation.created_at),
			employee_id: participation.employee_id,
			survey_name: participation.survey_name,
			survey_url: participation.survey_url,
			survey_id: participation.survey_id,
			status: participation.status,
			id: participation.id
		};
	}
}
